<script lang="tsx">
  import {
    defineComponent, computed, ref, PropType,
  } from 'vue'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import BeerIcon from '@xhs/yam-beer/cmp/common/Icon/Icon.vue'
  import { BeerStyleObj } from '@xhs/yam-beer/core'
  import initStyle, { AVATAR_SIZE_MAP } from './style'

  initStyle()

  type AvatarSize = 'large'| 'medium' | 'small'
  type AvatarFit = 'cover' | 'fill' | 'contain' | 'scale-down' | 'none'
  type AvatarShape = 'circle' | 'square'

  export default defineComponent({
    name: 'BeerAvatar',
    props: {
      /**
       * 容器 BeerStyle
       */
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * 当 src 加载失败或者不存在时，是否显示默认头像
       */
      showDefault: {
        type: Boolean as PropType<boolean>,
        default: true,
      },
      /**
       * 尺寸信息
       * @type {large|medium|small}
       * @see style
       */
      size: {
        type: [Number, String] as PropType<AvatarSize | number>,
        default: 'large',
      },
      /**
       * 形状
       * @type {circle|square}
       * @see style
       */
      shape: {
        type: String as PropType<AvatarShape>,
        default: 'circle',
      },
      /**
       * 图片加载失败后回调
       */
      onError: Function,
      /**
       * 图片的 fit 模式,
       * 使用场景，当图片尺寸小于头像尺寸的时候，contain + bg 可以保持图片没有拉伸
       * @type {cover|fill|contain|none|scale-down}
       * @see style
       */
      fit: {
        type: String as PropType<AvatarFit>,
        default: 'cover',
      },
      /**
       * 图片地址
       */
      src: {
        type: String,
        default: '',
      },
    },
    setup(props) {
      const isImageExist = ref(true)
      const wrapperBs: { value: BeerStyleObj } = computed(() => ({
        display: 'inline-block',
        boxSizing: 'border-box',
        textAlign: 'center',
        overflow: 'hidden',
        color: 'white',
        'cmp.avatar': 'size',
        ...props.bs,
        '.default-image': {
          height: '100%',
          verticalAlign: 'middle',
          display: 'block',
          objectFit: props.fit,
        },
        '.slot-default': {
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        },
      }))
      const sizeInPixel = computed(() => (typeof props.size === 'number' ? props.size : AVATAR_SIZE_MAP[props.size]))

      function handleError() {
        isImageExist.value = false
        if (props.onError) {
          props.onError()
        }
      }

      return () => {
        const canShowDefault = props.src && isImageExist.value
        return (
          <NewBsBox bs={wrapperBs.value}>
            {canShowDefault
              && <img
                src={props.src}
                role="img"
                class="default-image"
                onError={handleError}
              />}

            {!canShowDefault && props.showDefault
              && <div class="slot-default">
                <BeerIcon
                  size={sizeInPixel.value}
                  icon="mention-circle-f"
                  role="img"
                  color="outline"
                />
              </div>
            }

          </NewBsBox>
        )
      }
    },
  })
</script>
